export default __webpack_public_path__ + "static/media/private-investigations.784cb6ea.jpg";